module.exports = __webpack_public_path__ + "img/organizations-icon-dark.90b1600f.svg";